import { getStore } from '../store/store';
import { ObservableMap } from 'mobx';
import { dedupeObservableMapValues } from 'owa-selected-calendars-utils';

/**
 * Gets selected calendars from Time Panel store
 *
 * Prefer using `getTimePanelSelectedCalendarIdsMap` or `getTimePanelSelectedCalendarIdsFlatList` as
 * this selector is only meant for internal use where `hasTimePanelSelectedCalendars()` is true
 */
export function getSelectedCalendarsFromTimePanel(): ObservableMap<string, string[]> {
    return dedupeObservableMapValues(getStore().calendarIdsMap);
}
